import Vue from 'vue';
import './plugins/vuetify';
import './helpers/moment';

import App from './App.vue';
import router from './router';
import store from './store';
import './helpers/filters';
import './helpers/googleAutoComplete';
// import './helpers/registerServiceWorker';
import './main.scss';

// validation rules global
import validation from './helpers/validation';

Vue.config.productionTip = false;

Vue.prototype.$validation = validation;

new Vue({
  router,
  store,
  render: (h: any) => h(App),
}).$mount('#app');
